import type { AssessmentResultsDocument, AssessmentResultsListItem } from '../types/assessment-results/interfaces'
import type { AssessmentResultsStore } from './interfaces'
import type { ScopeMode } from '@shared/lib/scope'

import { beginEntry, failEntry, settleEntry } from '@shared/lib/scope'

export const actions = {
  beginList (this: AssessmentResultsStore, id: number, mode: ScopeMode): number {
    return beginEntry(this.listById, id, mode)
  },
  settleList (this: AssessmentResultsStore, id: number, requestId: number, data: AssessmentResultsListItem[]): void {
    settleEntry(this.listById, id, requestId, data)
  },
  failList (this: AssessmentResultsStore, id: number, requestId: number): void {
    failEntry(this.listById, id, requestId)
  },
  beginResult (this: AssessmentResultsStore, id: number, mode: ScopeMode): number {
    return beginEntry(this.resultById, id, mode)
  },
  settleResult (this: AssessmentResultsStore, id: number, requestId: number, data: AssessmentResultsDocument): void {
    settleEntry(this.resultById, id, requestId, data)
  },
  failResult (this: AssessmentResultsStore, id: number, requestId: number): void {
    failEntry(this.resultById, id, requestId)
  },
  markViewed (this: AssessmentResultsStore, disciplineId: number, assessmentId: number): void {
    const item = this.listById[disciplineId]?.data?.find(entry => entry.assessment_id === assessmentId)
    if (item) item.is_viewed = true
  },
}
